import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import { IUserType } from "../../../@types/userTypes";
import notification from "../../../apiConfigs/notifications";
import users, { UserRoleType } from "../../../apiConfigs/users";
import { ReactComponent as Ellipse } from "../../../assets/Ellipse.svg";
import { ReactComponent as Seperate } from "../../../assets/seperator.svg";
import { useRoot } from "../../../context/RootProvider";
import Button from "../../../designComponents/Button";
import DeleteModal from "../../../designComponents/DeleteModal";
import Loading from "../../../designComponents/Loading";
import { SelectUserRole } from "../../../designComponents/SelectRole";
import {
  EducationList,
  EmploymentHistory,
  renderRole,
  renderRoleSettings,
  renderSkills,
  renderstatus,
} from "../../../designComponents/Table/renderMethods";
import Typography from "../../../designComponents/Typography";
import {
  ADMIN_ROUTE,
  Notification_ROUTE,
  USERS_ROUTE,
} from "../../../routes/routePaths";
import { toCapitalCase } from "../../../utils/conversion";
import {
  humanReadableDate,
  humanReadableDateWithTime,
} from "../../../utils/date";
import requestAPI from "../../../utils/requestAPI";
import { resizeImage } from "../../../utils/resizeImages";
import {
  ActiveNavText,
  ButtonsSection,
  LabelText,
  Navigation,
  NavLink,
  NavText,
  SectionTitle,
  Title,
  ValueText,
  Wrapper,
} from "../../Properties/Details/styles";
import { UserDetailsWrapperStyled } from "./style";
import Transactions from "./Transactions";

type Props = {};

const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border: 1px solid #f1effb;
  gap: 20px;
  border-radius: 10px;
  padding: 20px;
  margin: 20px;
  font-family: Arial, sans-serif;
`;
const UserDetails = (props: Props) => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState<IUserType>();
  const [deleteModal, setDeleteModal] = useState(false);
  const [blockModal, setBlockModal] = useState<{
    status: boolean;
    role: UserRoleType | null;
    type?: "block" | "unblock";
  }>({ status: false, role: null });
  const [loading, setLoading] = useState<boolean>(true);

  const [userTransaction, setTransactions] = useState([]);
  const getUserDetails = async (id: string) => {
    setLoading(true);
    try {
      const response = await requestAPI(users.getUserDetails(id));

      setUserDetails(response);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const { auth } = useRoot();

  const blockedRoles = userDetails?.roleBasedSetting
    ?.filter((r) => r.isBlocked)
    ?.map((s) => s.role);

  const unblockedRoles = userDetails?.roleBasedSetting
    ?.filter((r) => !r.isBlocked)
    ?.map((s) => s.role);

  const handleDeleteUser = async () => {
    setLoading(true);
    try {
      if (userDetails?._id) {
        const response = await requestAPI(users.deleteUser(userDetails?._id));
        setLoading(false);
        console.log(response);
      }
      navigate(USERS_ROUTE);
      toast.success("User Deleted successfully");
    } catch (error) {
      console.log(error);
      setLoading(false);
    } finally {
    }
  };
  const handleBlockUser = async (role: UserRoleType) => {
    setLoading(true);
    try {
      if (userDetails?._id && role) {
        await requestAPI(users.blockUser(userDetails?._id, { role }));
        setLoading(false);
      }
      navigate(USERS_ROUTE);
      toast.success("User Blocked successfully");
    } catch (error) {
      console.log(error);
      setLoading(false);
    } finally {
    }
  };
  const handleUnblockUser = async (role: UserRoleType) => {
    setLoading(true);
    try {
      if (userDetails?._id && role) {
        await requestAPI(users.unblockUser(userDetails?._id, { role }));
        setLoading(false);
      }
      navigate(USERS_ROUTE);
      toast.success("User Unblocked successfully");
    } catch (error) {
      console.log(error);
      setLoading(false);
    } finally {
    }
  };

  const [notifications, setNotifications] = useState<any[]>([]);
  const getNotifications = async () => {
    const response = await requestAPI(
      notification.getNotifications({ notifiedTo: userId })
    );
    setNotifications(response.data);
  };
  useEffect(() => {
    if (userId) {
      getUserDetails(userId);
      getNotifications();
    }
  }, [userId]);

  const fullName = `${userDetails?.firstName || ""} ${
    userDetails?.lastName || ""
  }`;
  return (
    <UserDetailsWrapperStyled>
      {loading ? (
        <Loading />
      ) : (
        <Wrapper>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              <Title>{fullName || "User"}</Title>
              <Navigation
                style={{
                  paddingTop: 13,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <NavLink onClick={() => navigate(ADMIN_ROUTE)}>
                  <NavText>Table</NavText>
                </NavLink>
                <Seperate fill="#7E7E7E"></Seperate>

                <ActiveNavText>User details</ActiveNavText>
              </Navigation>
            </div>
            <div style={{ display: "flex", gap: 40 }}>
              {/* {auth?.role === "ADMIN" && (
                <Button
                  style={{
                    border: "1px solid #D8D8D8",
                    color: "#7E7E7E",
                    borderRadius: 6,
                    backgroundColor: "transparent",
                  }}
                  onClick={() => {
                    setDeleteModal(true);
                  }}
                >
                  Delete User
                </Button>
              )} */}
              <Button
                style={{ backgroundColor: "#725ED4", borderRadius: 6 }}
                onClick={() => {
                  navigate(`/editUser/${userDetails?._id}`);
                }}
              >
                Edit User
              </Button>
              {(blockedRoles || [])?.length <
                (userDetails?.roles || [])?.length && (
                <Button
                  style={{ backgroundColor: "#D92D20", borderRadius: 6 }}
                  onClick={() => {
                    if (userDetails?.roles?.length === 1) {
                      setBlockModal({
                        status: true,
                        role: userDetails?.defaultRole,
                        type: "block",
                      });
                    } else {
                      setBlockModal({
                        status: true,
                        role: null,
                        type: "block",
                      });
                    }
                  }}
                >
                  Block User
                </Button>
              )}
              {(unblockedRoles || [])?.length <
                (userDetails?.roles || [])?.length && (
                <Button
                  style={{ backgroundColor: "#20b4d9", borderRadius: 6 }}
                  onClick={() => {
                    if (userDetails?.roles?.length === 1) {
                      setBlockModal({
                        status: true,
                        role: userDetails?.defaultRole,
                        type: "unblock",
                      });
                    } else {
                      setBlockModal({
                        status: true,
                        role: null,
                        type: "unblock",
                      });
                    }
                  }}
                >
                  Unblock User
                </Button>
              )}
            </div>
          </div>

          <ButtonsSection>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                gap: 20,
              }}
            >
              <Card style={{ margin: 0 }}>
                <SectionTitle>Information Detail</SectionTitle>
                <div>
                  <img
                    style={{ borderRadius: 50 }}
                    src={resizeImage(userDetails?.avatar ?? "", "sm") ?? ""}
                    alt="profile"
                    width={100}
                    height={100}
                  ></img>
                </div>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 8 }}
                >
                  <ButtonsSection>
                    <LabelText>Full Name</LabelText>
                    <ValueText>
                      {userDetails?.firstName + " " + userDetails?.lastName}
                    </ValueText>
                  </ButtonsSection>

                  <ButtonsSection>
                    <LabelText>User ID</LabelText>
                    <ValueText>#{userDetails?._id}</ValueText>
                  </ButtonsSection>

                  <ButtonsSection>
                    <LabelText>Status Badge</LabelText>
                    {renderstatus("ACTIVE")}
                  </ButtonsSection>
                  <ButtonsSection>
                    <LabelText>Member Since</LabelText>
                    <ValueText>
                      {humanReadableDate(userDetails?.createdAt)}
                    </ValueText>
                  </ButtonsSection>
                  <ButtonsSection>
                    <LabelText>Is Verified</LabelText>
                    <ValueText>
                      {userDetails?.isDocumentVerified
                        ? "Verified"
                        : "Not Verified"}
                    </ValueText>
                  </ButtonsSection>
                  <ButtonsSection>
                    <LabelText>Profile Completed</LabelText>
                    <ValueText>
                      {userDetails?.isProfileComplete
                        ? "Completed"
                        : "Not Completed"}
                    </ValueText>
                  </ButtonsSection>

                  <ButtonsSection>
                    <LabelText>Profile Visible</LabelText>
                    <ValueText>
                      {userDetails?.visibleProfile ? "Public" : "Private"}
                    </ValueText>
                  </ButtonsSection>
                  <ButtonsSection>
                    <LabelText>Phone Verified</LabelText>
                    <ValueText>
                      {userDetails?.isPhoneVerified
                        ? "Verified"
                        : "Not Verified"}
                    </ValueText>
                  </ButtonsSection>
                  <ButtonsSection>
                    <LabelText>Email Verified</LabelText>
                    <ValueText>
                      {userDetails?.isEmailVerified
                        ? "Verified"
                        : "Not Verified"}
                    </ValueText>
                  </ButtonsSection>
                  <ButtonsSection>
                    <LabelText>Account Type</LabelText>
                    <ValueText>{userDetails?.accountType?.type}</ValueText>
                  </ButtonsSection>
                  {userDetails?.accountType?.type !== "INDIVIDUAL" && (
                    <ButtonsSection>
                      <LabelText>Company Name</LabelText>
                      <ValueText>
                        {userDetails?.accountType?.companyName}
                      </ValueText>
                    </ButtonsSection>
                  )}
                  {userDetails?.accountType?.type !== "INDIVIDUAL" && (
                    <ButtonsSection>
                      <LabelText>Company Website</LabelText>
                      <ValueText>
                        {userDetails?.accountType?.companyWebsite}
                      </ValueText>
                    </ButtonsSection>
                  )}
                </div>
              </Card>

              <Card style={{ margin: 0 }}>
                <SectionTitle>User Detail</SectionTitle>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 8 }}
                >
                  <ButtonsSection>
                    <LabelText>Full Name</LabelText>
                    <ValueText>
                      {userDetails?.firstName + " " + userDetails?.lastName}
                    </ValueText>
                  </ButtonsSection>

                  <ButtonsSection>
                    <LabelText>Email</LabelText>
                    <ValueText>{userDetails?.email}</ValueText>
                  </ButtonsSection>

                  <ButtonsSection>
                    <LabelText>Address</LabelText>
                    <ValueText>{userDetails?.address}</ValueText>
                  </ButtonsSection>
                  <ButtonsSection>
                    <LabelText>Phone Number</LabelText>
                    <ValueText>
                      {userDetails?.countryCode
                        ? "(" + userDetails?.countryCode + ")"
                        : null}{" "}
                      {userDetails?.phone}
                    </ValueText>
                  </ButtonsSection>

                  <ButtonsSection>
                    <LabelText>Roles</LabelText>
                    {renderRole(userDetails?.roles ?? "null")}
                  </ButtonsSection>

                  <ButtonsSection>
                    <LabelText>Status</LabelText>
                    {renderstatus("ACTIVE")}
                  </ButtonsSection>
                  <ButtonsSection>
                    <LabelText>User Rating</LabelText>
                    <ValueText>#{userDetails?.rating}</ValueText>
                  </ButtonsSection>
                  <ButtonsSection>
                    <LabelText>Skills</LabelText>
                    <div>{renderSkills(userDetails?.skills ?? [])}</div>
                  </ButtonsSection>
                  {renderRoleSettings(userDetails?.roleBasedSetting ?? [])}
                </div>
              </Card>
              <Card style={{ margin: 0 }}>
                <SectionTitle>Education</SectionTitle>
                {userDetails?.education ? (
                  <EducationList
                    education={userDetails?.education}
                  ></EducationList>
                ) : (
                  <Typography>No Education Background yet</Typography>
                )}
              </Card>
              <Card style={{ margin: 0 }}>
                <SectionTitle>Work History</SectionTitle>
                {userDetails?.employmentHistory ? (
                  <EmploymentHistory
                    education={userDetails?.employmentHistory || []}
                  ></EmploymentHistory>
                ) : (
                  <Typography>No Education Background yet</Typography>
                )}
              </Card>
              <Card style={{ margin: 0 }}>
                <SectionTitle>Rental History</SectionTitle>
                {userDetails?.rentalHistory ? (
                  // <EmploymentHistory
                  //   education={userDetails?.employmentHistory}
                  // ></EmploymentHistory>
                  <LabelText>No rental History</LabelText>
                ) : (
                  <Typography>No Rental history yet</Typography>
                )}
              </Card>
              <Card style={{ margin: 0 }}>
                <SectionTitle>Certifications</SectionTitle>
                {userDetails?.certificate ? (
                  // <EmploymentHistory
                  //   education={userDetails?.employmentHistory}
                  // ></EmploymentHistory>
                  <LabelText>No Certifications</LabelText>
                ) : (
                  <Typography>No Certifications yet</Typography>
                )}
              </Card>
              <Transactions userId={userId ?? ""}></Transactions>
            </div>

            <div
              style={{
                width: "200px",
                padding: "16px",
                borderRadius: "8px",
              }}
            >
              <Typography
                size={"h4"}
                fontWeight="semibold"
                style={{ color: "#242B50", marginBottom: "16px" }}
              >
                Activity Notifications
              </Typography>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {notifications.map((item, index) => {
                  return (
                    <div
                      style={{
                        padding: "8px 8px 8px 32px",
                        borderLeft: "1px dotted #E3DFF6",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          position: "relative",
                        }}
                      >
                        <Ellipse
                          fill="#F9F9FD"
                          style={{
                            position: "absolute",
                            left: "-40px",
                            top: "50%",
                            transform: "translateY(-50%)",
                          }}
                        ></Ellipse>

                        <div>
                          <Typography size={"h5"} style={{ color: "#333" }}>
                            {item.title}
                          </Typography>
                          <Typography size={"h6"} style={{ color: "#333" }}>
                            {item.description}
                          </Typography>
                          <Typography
                            style={{ color: "#777", fontSize: "12px" }}
                          >
                            {humanReadableDateWithTime(item.createdAt)}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  );
                })}
                {notifications.length >= 10 && (
                  <div
                    onClick={() => {
                      navigate(`${Notification_ROUTE}?userId=${userId}`);
                    }}
                  >
                    <Typography
                      size={"h6"}
                      style={{
                        color: "#806ED8",
                        cursor: "pointer",
                        textDecoration: "underline",
                        textAlign: "right",
                        marginTop: "10px",
                      }}
                    >
                      Show All Notifications
                    </Typography>
                  </div>
                )}
              </div>
            </div>
          </ButtonsSection>
          <DeleteModal
            loading={loading}
            itemName={`${userDetails?.firstName}  ${userDetails?.lastName}`}
            isOpen={deleteModal}
            onClose={() => {
              setDeleteModal(false);
            }}
            onDelete={() => {
              handleDeleteUser();
            }}
            title={`Are you Sure You want to Block this User's Account `}
            type="delete"
          />
          <DeleteModal
            type="block"
            loading={loading}
            itemName={`${userDetails?.firstName}  ${userDetails?.lastName}`}
            isOpen={
              blockModal?.status &&
              !!blockModal?.role &&
              blockModal?.type === "block"
            }
            onClose={() => {
              setBlockModal({ status: false, role: null });
            }}
            onDelete={() => {
              if (blockModal?.role) {
                handleBlockUser(blockModal?.role);
              }
            }}
            title={`Are you Sure You want to Block this User's ${toCapitalCase(
              blockModal?.role || ""
            )} Account `}
          />
          <DeleteModal
            type="unblock"
            loading={loading}
            itemName={`${userDetails?.firstName}  ${userDetails?.lastName}`}
            isOpen={
              blockModal?.status &&
              !!blockModal?.role &&
              blockModal?.type === "unblock"
            }
            onClose={() => {
              setBlockModal({ status: false, role: null });
            }}
            onDelete={() => {
              if (blockModal?.role) {
                handleUnblockUser(blockModal?.role);
              }
            }}
            title={`Are you Sure You want to Unblock this User's ${toCapitalCase(
              blockModal?.role || ""
            )} Account `}
          />
          <SelectUserRole
            visible={blockModal?.status && !blockModal?.role}
            onClose={() => {
              setBlockModal({ role: null, status: false });
            }}
            onSelect={(role) => {
              setBlockModal((prev) => ({ ...prev, role }));
            }}
            rolesOptions={
              blockModal?.type === "unblock"
                ? blockedRoles || []
                : unblockedRoles || []
            }
          />
        </Wrapper>
      )}
    </UserDetailsWrapperStyled>
  );
};

export default UserDetails;
